<div class="search-item-wrapper">
    <div class="title-wrapper">
        <div>{{ area().areaName }}</div>
        <div class="sub-title">
            <span>{{ area().areaTypeName }}</span>
            <span class="sub-title--extra-info">
                @if(area().areaTypeId === areaType.Municipality) {
                {{ area().countyName }}
                }@else{
                {{ area().municipalityName }}
                }</span
            >
        </div>
    </div>
    <div class="button-wrapper">
        @if(isSelected()){
        <button (click)="removeArea($event)" class="icon-button">
            <span class="icon icon-remove"></span
            ><span class="label label--remove">Fjern</span>
        </button>
        }@else {
        <button (click)="addArea($event)" class="icon-button">
            <span class="icon icon-add"></span
            ><span class="label label--add">Velg</span>
        </button>
        }
    </div>
</div>
